import { render, staticRenderFns } from "./Edit-Statement.vue?vue&type=template&id=181f2ce1&scoped=true"
import script from "./Edit-Statement.vue?vue&type=script&lang=js"
export * from "./Edit-Statement.vue?vue&type=script&lang=js"
import style0 from "./Edit-Statement.vue?vue&type=style&index=0&id=181f2ce1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f2ce1",
  null
  
)

export default component.exports